module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.isLoading,
      "text": "加载中"
    }
  }), _vm._v(" "), _c('top-tips'), _vm._v(" "), _c('div', {
    staticClass: "remote-panel"
  }, [_c('div', {
    staticClass: "top-btns"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "power",
      "value": _vm.currentRid['1'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "signal",
      "value": _vm.currentRid['111'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "menu",
      "value": _vm.currentRid['45'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "back",
      "value": _vm.currentRid['116'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "volume-button"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "home",
      "value": _vm.currentRid['136'],
      "onClick": _vm.onClick,
      "isShowTitle": false
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('volume-button', {
    attrs: {
      "title": "音量",
      "plusValue": _vm.currentRid['50'],
      "subValue": _vm.currentRid['51'],
      "onClick": _vm.onClick
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "mute",
      "value": _vm.currentRid['106'],
      "onClick": _vm.onClick,
      "isShowTitle": false
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "direction-button"
  }, [_c('direction-button', {
    attrs: {
      "onClick": _vm.onClick,
      "leftValue": _vm.currentRid['48'],
      "rightValue": _vm.currentRid['49'],
      "upValue": _vm.currentRid['46'],
      "downValue": _vm.currentRid['47'],
      "confirmValue": _vm.currentRid['42']
    }
  })], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('action-button', {
    attrs: {
      "totalCount": _vm.irDataList.length + 1,
      "currentHandle": _vm.current,
      "nextHandle": _vm.next,
      "preHandle": _vm.pre
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-554d5870"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/tv/Index.vue
// module id = 897
// module chunks = 1